export const en = {
  'brand.name': 'PAPO',
  'brand.full': 'African Power for the Organized',
  'brand.subtitle': 'African Power',
  'brand.suffix': 'for the Organized',
  'brand.copyright': '© 2026 PAPO: African Power for the Organized. Free Africa, our Africa.',
  'landing.slogan.0': 'Where our voice will not be silenced \u2013 Free Africa, our Africa.',
  'landing.slogan.1': 'Without fear, without muzzle \u2013 for an Africa of rights and justice.',
  'landing.slogan.2': 'United against the regime that oppresses us \u2013 freedom is not a crime.',
  'landing.slogan.3': 'From nepotism to hope: together for a sovereign Africa.',
  'landing.slogan.4': 'Speak, Africa! Here the people denounce, resist and build the future.',
  'landing.slogan.5': 'Create your Africa. Without fear, without censorship, only talent and new stories.',
  'landing.login': 'Log In',
  'landing.register': 'Join Us',
  'landing.join': 'Join the resistance',
  'landing.haveAccount': 'I have an account',
  'landing.createAccount': 'Create my account',
  'landing.feat.safe.title': 'Safe Space',
  'landing.feat.safe.desc': 'Protected from censorship and surveillance. Your voice, your freedom.',
  'landing.feat.community.title': 'United Community',
  'landing.feat.community.desc': 'Connect with organized Africans fighting for sovereignty and justice.',
  'landing.feat.resist.title': 'Report and Resist',
  'landing.feat.resist.desc': 'Report abuses, share testimonies, build the future of Africa.',
  'landing.feat.privacy.title': 'Total Privacy',
  'landing.feat.privacy.desc': 'Your data will never be sold. We comply with international law.',
  'landing.different': 'A social network',
  'landing.different2': 'like no other',
  'landing.differentDesc': 'Created by and for Africans who want to live free from the regime.',
  'landing.heroCaption': 'Speak, Africa! Here the people denounce, resist and build the future.',
  'landing.values': 'Our Values',
  'landing.valuesTitle': 'Building a',
  'landing.valuesDemocratic': 'sovereign Africa',
  'landing.power.title': 'Power to the People',
  'landing.power.desc': 'Every voice counts. Every report matters. Together we are stronger.',
  'landing.transparency.title': 'Transparency',
  'landing.transparency.desc': 'No manipulative algorithms. No data sold. No censorship.',
  'landing.unity.title': 'African Unity',
  'landing.unity.desc': 'An inclusive space for all Africans who dream of freedom.',
  'landing.cta.title': 'Freedom is not a crime',
  'landing.cta.desc': 'United against the regime that oppresses us. Join PAPO and be part of the change.',
  'nav.home': 'Home',
  'nav.groups': 'Groups',
  'nav.events': 'Events',
  'nav.messages': 'Messages',
  'nav.wallet': 'Wallet',
  'nav.analytics': 'Analytics',
  'analytics.title': 'Analytics',
  'analytics.subtitle': 'Interaction stats and trends',
  'analytics.reactions': 'Reactions',
  'analytics.comments': 'Comments',
  'analytics.messages': 'Messages',
  'analytics.profileViews': 'Profile views',
  'analytics.yourEngagement': 'Your engagement',
  'analytics.othersEngagement': 'Others engagement',
  'analytics.totalOutgoing': 'Interactions you made',
  'analytics.totalIncoming': 'Interactions you received',
  'analytics.topFriends': 'Most engaged friends',
  'analytics.noData': 'No interaction data yet',
  'analytics.activityChart': 'Activity last 30 days',
  'analytics.noActivity': 'No activity in this period',
  'analytics.posts': 'Posts',
  'nav.profile': 'My profile',
  'nav.settings': 'Settings',
  'nav.logout': 'Log out',
  'auth.email': 'Email',
  'auth.password': 'Password',
  'auth.confirmPassword': 'Confirm password',
  'auth.name': 'Full name',
  'auth.login': 'Log In',
  'auth.register': 'Create account',
  'auth.logging': 'Logging in...',
  'auth.registering': 'Creating account...',
  'auth.loginTitle': 'Log into your account',
  'auth.registerTitle': 'Create your account',
  'auth.loginSubtitle': 'Your voice matters. Africa needs you.',
  'auth.registerSubtitle': 'Join the community that is changing Africa.',
  'auth.noAccount': "Don't have an account?",
  'auth.haveAccount': 'Already have an account?',
  'auth.registerLink': 'Create one now',
  'auth.loginLink': 'Log in here',
  'auth.googleLogin': 'Continue with Google',
  'auth.backHome': 'Back to home',
  'auth.fillAll': 'Please fill in all fields',
  'auth.passNoMatch': 'Passwords do not match',
  'auth.passMin': 'Password must be at least 6 characters',
  'auth.welcomeBack': 'Welcome back!',
  'auth.welcome': 'Welcome to PAPO!',
  'auth.loginError': 'Login error',
  'auth.sessionExpired': 'Your session has expired. Please log in again.',
  'auth.registerError': 'Registration error',
  'dash.createPost': 'What do you want to share?',
  'dash.share': 'Share',
  'dash.myGroups': 'My groups',
  'dash.seeAllGroups': 'See all',
  'dash.upcomingEvents': 'Upcoming events',
  'dash.seeAllEvents': 'See all',
  'dash.members': 'members',
  'dash.loadError': 'Error loading feed',
  'dash.releaseToRefresh': 'Release to refresh',
  'groups.title': 'Groups',
  'groups.search': 'Search groups...',
  'groups.create': 'Create group',
  'groups.new': 'New group',
  'groups.name': 'Group name',
  'groups.description': 'Description',
  'groups.category': 'Category',
  'groups.creating': 'Creating...',
  'groups.join': 'Join',
  'groups.leave': 'Leave',
  'groups.joined': 'Member',
  'groups.noGroups': 'No groups found',
  'groups.loadError': 'Error loading groups',
  'groups.createError': 'Error creating group',
  'groups.created': 'Group created!',
  'groups.fillAll': 'Fill in all fields',
  'groups.joinedMsg': 'You joined the group',
  'groups.leftMsg': 'You left the group',
  'groups.cat.all': 'All',
  'groups.cat.general': 'General',
  'groups.cat.wellness': 'Wellness',
  'groups.cat.mindfulness': 'Mindfulness',
  'groups.cat.creativity': 'Creativity',
  'groups.cat.support': 'Support',
  'groups.cat.learning': 'Learning',
  'events.title': 'Events',
  'events.create': 'Create event',
  'events.new': 'New event',
  'events.eventTitle': 'Title',
  'events.description': 'Description',
  'events.date': 'Date',
  'events.location': 'Location',
  'events.creating': 'Creating...',
  'events.attend': 'Attend',
  'events.attending': 'Attending',
  'events.attendees': 'attendees',
  'events.noEvents': 'No events found',
  'events.loadError': 'Error loading events',
  'events.createError': 'Error creating event',
  'events.created': 'Event created!',
  'events.fillAll': 'Fill in all required fields',
  'events.attendOk': 'Registration confirmed!',
  'events.unattendOk': 'You are no longer attending',
  'events.attendError': 'Error processing request',
  'msg.title': 'Messages',
  'msg.search': 'Search users...',
  'msg.typeMessage': 'Type a message...',
  'msg.noConversations': 'No conversations yet',
  'msg.startChat': 'Start a conversation',
  'msg.selectChat': 'Select a conversation',
  'msg.sendError': 'Error sending message',
  'msg.report': 'Report user',
  'msg.block': 'Block user',
  'search.title': 'Search results',
  'search.placeholder': 'Search...',
  'search.for': 'Results for',
  'search.error': 'Search error',
  'search.all': 'All',
  'search.people': 'People',
  'search.posts': 'Posts',
  'search.groups': 'Groups',
  'search.hashtags': 'Hashtags',
  'search.searching': 'Searching...',
  'search.results': 'results',
  'search.users': 'Users',
  'search.posts': 'Posts',
  'search.groups': 'Groups',
  'search.events': 'Events',
  'search.hashtags': 'Hashtags',
  'wellness.title': 'Your wellness',
  'wellness.session': 'Session',
  'wellness.dailyUsage': 'Daily usage',
  'wellness.nearLimit': 'You are near your daily limit. Consider taking a break.',
  'wellness.reminder': 'Social media is a tool, not an obligation.',
  'wellness.takeBreak': 'Take a break',
  'wellness.breakTitle': 'Time for a break',
  'wellness.sessionTime': 'Session time',
  'wellness.minutes': 'minutes',
  'wellness.inhale': 'Inhale',
  'wellness.hold': 'Hold',
  'wellness.exhale': 'Exhale',
  'wellness.notNow': 'Not now',
  'wellness.break5': '5 min break',
  'wellness.restMode': 'Rest Mode',
  'wellness.endBreak': 'End break',
  'wellness.weeklyTitle': 'Weekly Wellness',
  'wellness.weeklySubtitle': 'Your last 7 days',
  'wellness.totalWeek': 'Total week',
  'wellness.avgDaily': 'Daily average',
  'wellness.breaksTaken': 'Breaks taken',
  'wellness.streak': 'Day streak',
  'wellness.currentSession': 'Current session',
  'post.comment': 'Write a comment...',
  'post.comments': 'comments',
  'post.loadComments': 'View comments',
  'post.deleteConfirm': 'Delete post?',
  'post.report': 'Report',
  'post.block': 'Block',
  'post.moderation': 'Moderation status',
  'post.tip': 'Tip',
  'post.delete': 'Delete',
  'wallet.title': 'Wallet',
  'wallet.balance': 'Total balance',
  'wallet.send': 'Send',
  'wallet.receive': 'Receive',
  'wallet.swap': 'Swap',
  'wallet.stake': 'Staking',
  'wallet.transactions': 'Transactions',
  'wallet.noTransactions': 'No transactions',
  'donation.title': 'Support PAPO',
  'donation.desc': 'Your donation helps keep the platform alive and independent.',
  'donation.copy': 'Copy',
  'donation.copied': 'Copied!',
  'settings.title': 'Settings',
  'settings.account': 'Account',
  'settings.privacy': 'Privacy',
  'settings.notifications': 'Notifications',
  'settings.wellness': 'Wellness',
  'settings.theme': 'Theme',
  'settings.language': 'Language',
  'settings.export': 'Export data',
  'settings.delete': 'Delete account',
  'profile.followers': 'Followers',
  'profile.following': 'Following',
  'profile.posts': 'Posts',
  'profile.follow': 'Follow',
  'profile.suggestions': 'Suggestions',
  'profile.noSuggestions': 'No suggestions right now',
  'friends.addFriend': 'Add friend',
  'friends.friends': 'Friends',
  'friends.pending': 'Pending',
  'friends.accept': 'Accept',
  'friends.requestSent': 'Friend request sent',
  'friends.accepted': 'You are now friends!',
  'friends.removed': 'Friend removed',
  'circles.title': "Circles",
  'circles.new': "New circle",
  'circles.edit': "Edit circle",
  'circles.intro': "Group your friends (Family, Work…) and post just for them.",
  'circles.empty': "You have no circles yet",
  'circles.member': "member",
  'circles.members': "members",
  'circles.confirmDelete': "Delete this circle? Posts made for it will only be visible to you.",
  'circles.namePlaceholder': "Circle name (e.g. Family)",
  'circles.pickFriends': "Choose friends",
  'circles.save': "Save",
  'circles.saved': "Circle saved",
  'circles.allFriends': "All my friends",
  'circles.badge': "Circle",
  'friends.one': 'Friend',
  'friends.confirmRemove': "Are you sure you want to remove this friend?",
  'friends.privateProfile': 'Private profile',
  'friends.privateDesc': 'This profile is private. Add as a friend to see their posts.',
  'friends.requests': 'Friend requests',
  'friends.noRequests': 'No pending requests',
  'suggestions.title': 'People you may know',
  'suggestions.mutualFriends': 'mutual friends',
  'suggestions.fromContacts': 'From your contacts',
  'suggestions.newOnPapo': 'New on PAPO',
  'suggestions.noSuggestions': 'No suggestions right now',
  'suggestions.syncContacts': 'Sync contacts',
  'suggestions.syncDesc': 'Find your phone friends on PAPO',
  'suggestions.contactsSynced': 'Contacts synced',
  'suggestions.synced': 'contacts synced',
  'suggestions.syncError': 'Error syncing contacts',
  'suggestions.manualPrompt': 'Enter your contacts emails or phone numbers separated by commas:',
  'msg.ephemeral': 'Ephemeral message',
  'msg.ephemeralToggle': 'Message disappears after reading',
  'msg.ephemeralActive': 'Ephemeral mode on — messages disappear after reading',
  'friendRequests.title': 'Friend requests',
  'friendRequests.nav': 'Requests',
  'friendRequests.incoming': 'Received',
  'friendRequests.sent': 'Sent',
  'friendRequests.noIncoming': 'No incoming requests',
  'friendRequests.noSent': 'No sent requests',
  'friendRequests.noFriends': 'No friends yet',
  'friendRequests.wantsToBeYourFriend': 'Wants to be your friend',
  'friendRequests.pendingSent': 'Pending request',
  'friendRequests.remove': 'Remove',
  'friends.requestRejected': 'Request rejected',
  'profile.unfollow': 'Unfollow',
  'profile.edit': 'Edit profile',
  'profile.bio': 'Bio',
  'common.loading': 'Loading...',
  'common.now': 'just now',
  'common.save': 'Save',
  'common.cancel': 'Cancel',
  'common.close': 'Close',
  'common.back': 'Back',
  'common.min': 'min',
  'common.ago': 'ago',
  'pwa.install': 'Install App',
  'pwa.installDesc': 'Install PAPO on your device',
  'dash.addBio': 'Add a bio so others can get to know you better.',
  'dash.viewProfile': 'View profile',
  'dash.quickActions': 'Quick actions',
  'dash.exploreGroups': 'Explore groups',
  'dash.viewEvents': 'View events',
  'dash.noPosts': 'No posts yet. Be the first to share!',
  'dash.reactError': 'Reaction error',
  'events.subtitle': 'Discover experiences that enrich your life',
  'events.noEventsDay': 'No events on this day',
  'groups.chat': 'Chat',
  'groups.noMessages': 'No messages yet',
  'groups.typeMessage': 'Type a message...',
  'groups.noPosts': 'No posts yet. Share something!',
  'chat.typing': 'is typing...',
  'polls.create': 'Create poll',
  'polls.question': 'Question...',
  'polls.option': 'Option',
  'polls.addOption': 'Add option',
  'polls.publish': 'Publish poll',
  'polls.votes': 'votes',
  'help.title': 'PAPO Guide',
  'help.subtitle': 'Everything you need to know to use the social network, step by step.',
  'help.contact': 'Got questions? Contact',
  'help.start': 'Start using PAPO',
  'events.upcoming': 'Upcoming events',
  'events.past': 'Past events',
  'events.selectDate': 'Select a date',
  'events.noEventsDesc': 'Be the first to organize an event for the community!',
  'events.createFirst': 'Create the first event',
  'events.confirmed': 'Confirmed',
  'events.participated': 'participated',
  'events.locationOpt': 'Location (optional)',
  'events.titleLabel': 'Event title',
  'groups.subtitle': 'Connect with communities that share your interests',
  'groups.noGroupsFilter': 'No groups match those filters',
  'groups.noGroupsDesc': 'Be the first to create a group!',
  'groups.createFirst': 'Create the first group',
  'groups.membersCount': 'members',
  'groups.groupNamePh': 'E.g.: Africans for sovereignty',
  'groups.groupDescPh': 'What is your group about?',
  'groups.processError': 'Error processing request',
  'msg.you': 'You',
  'msg.online': 'Online',
  'msg.today': 'Today',
  'notif.title': 'Notifications',
  'notif.empty': 'No notifications',
  'notif.emptyDesc': 'When someone interacts with you, it will appear here.',
  'notif.markRead': 'Mark as read',
  'notif.enableBrowser': 'Enable notifications',
  'notif.enabled': 'Notifications enabled',
  'notif.disabled': 'Push notifications disabled',
  'notif.denied': 'Notifications blocked. Enable them in browser settings.',
  'notif.enablePush': 'Enable push',
  'notif.pushActive': 'Push active',
  'notif.blocked': 'Blocked',
  'notif.reaction': 'reacted to your post',
  'notif.comment': 'commented on your post',
  'notif.follow': 'started following you',
  'notif.group': 'joined your group',
  'post.createTitle': 'Create post',
  'post.placeholder': 'What do you want to share?',
  'post.posting': 'Posting...',
  'post.publish': 'Publish',
  'post.addImage': 'Add image',
  'report.title': 'Report content',
  'report.reason': 'Report reason',
  'report.submit': 'Submit report',
  'report.success': 'Report sent. Thank you.',
  'donation.support': 'Support',
  'post.share': 'Share',
  'post.linkCopied': 'Link copied!',
  'post.commentBtn': 'Comment',
  'admin.title': 'Admin Panel',
  'admin.reports': 'Reports',
  'admin.users': 'Users',
  'admin.moderation': 'Moderation',
  'admin.stats': 'Statistics',
  'admin.noReports': 'No pending reports',
  'admin.resolve': 'Resolve',
  'admin.dismiss': 'Dismiss',
  'admin.totalUsers': 'Total users',
  'admin.totalPosts': 'Total posts',
  'admin.totalGroups': 'Total groups',
  'admin.pendingReports': 'Pending reports',
  'settings.darkMode': 'Dark mode',
  'settings.lightMode': 'Light mode',
  'settings.themeAuto': 'Auto',
  'stories.addStory': 'Add story',
  'stories.yourStory': 'Your story',
  'stories.viewers': 'Viewers',
  'stories.delete': 'Delete',
  'stories.placeholder': 'Write something...',
  'stories.create': 'Create story',
  'stories.uploadMedia': 'Photo/Video',
  'stories.react': 'React',
  'mention.placeholder': 'Mention @user',
  'trending.title': 'Trending',
  'poll.vote': 'Vote',
  'poll.votes': 'votes',
  'poll.voted': 'Voted',
  'poll.ended': 'Ended',
  'poll.createPoll': 'Create poll',
  'poll.question': 'Question',
  'poll.option': 'Option',
  'poll.addOption': 'Add option',
  'poll.duration': 'Duration (hours)',
  'groupChat.title': 'Group chat',
  'groupChat.send': 'Send',
  'groupChat.placeholder': 'Message...',
  'groupChat.empty': 'No messages yet. Be the first!',
  'post.deletePost': 'Delete post',
  'post.reportContent': 'Report content',
  'post.blockUser': 'Block user',
  'post.reactions': 'reactions',
  'post.tips': 'tip',
  'post.tipsPlural': 'tips',
  'post.comments': 'comments',
  'post.firstComment': 'Be the first to comment',
  'post.commentPlaceholder': 'Write a comment...',
  'post.postDeleted': 'Post deleted',
  'post.postDeleteError': 'Error deleting post',
  'post.blockSuccess': 'User blocked',
  'post.blockError': 'Error blocking user',
  'post.copyError': 'Error copying',
  'post.commentError': 'Error posting comment',
  'post.loadCommentsError': 'Error loading comments',
  'post.moderationWarning': 'Moderation warning:',
  'post.contentHidden': 'Content hidden by moderation',
  'post.publicPost': 'Public post',
  'post.groupPost': 'Group post',
  'post.fileNotAllowed': 'File type not allowed',
  'post.writeOrAdd': 'Write something or add a file',
  'post.created': 'Post created!',
  'post.createError': 'Error creating post',
  'post.uploaded': 'uploaded',
  'post.formDesc': 'Form to create a new post',
  'dash.noGroups': 'No groups available',
  'dash.noEvents': 'No upcoming events',
  'dash.conecta': 'Connect and satisfy your needs',
  'dash.simbinDesc': 'African entertainment network',
  'dash.assertiveDesc': 'Professional networking platform',
  'trending.posts': 'posts',
  'stories.photoVideoOnly': 'Photos or videos only',
  'stories.created': 'Story created!',
  'stories.error': 'Error',
  'search.placeholder': 'Search people, posts, groups, #hashtags...',
  'msg.searchPeople': 'Search people...',
  'msg.writePlaceholder': 'Write a message...',
  'groups.members': 'Members',
  'tip.send': 'Send tip',
  'tip.placeholder': 'Amount',
  'tip.error': 'Error sending tip',
  'tip.amountError': 'Enter a valid amount',
  'donation.title': 'This is just the beginning',
  'donation.subtitle': 'PAPO needs your help',
  'donation.copy': 'Copy',
  'donation.copied': 'Copied!',
  'donation.addresses': 'Donation addresses',
  'report.sent': 'Report sent',
  'report.close': 'Close',
  'report.minChars': 'Select a category and describe the issue (minimum 10 characters)',
  'report.title': 'Report content',
  'report.legalNote': 'Your report will be reviewed under International Law and EU legislation.',
  'report.categoryLabel': 'Report category',
  'report.categoryPlaceholder': 'Select a category...',
  'report.descLabel': 'Description',
  'report.descPlaceholder': 'Describe the issue in detail (minimum 10 characters)...',
  'report.urgentNote': 'If there is immediate risk to life, contact local emergency services. Urgent reports are automatically escalated.',
  'report.submit': 'Submit report',
  'report.submitting': 'Submitting...',
  'report.received': 'Report received',
  'report.priority': 'Priority',
  'report.urgent': 'Urgent',
  'report.standard': 'Standard',
  'report.legalFrameworks': 'Applicable legal frameworks',
  'report.submitError': 'Error submitting report',
  'report.cat.spam': 'Spam',
  'report.cat.harassment': 'Harassment',
  'report.cat.cyberbullying': 'Cyberbullying',
  'report.cat.threats': 'Threats',
  'report.cat.hate_speech': 'Hate speech',
  'report.cat.discrimination': 'Discrimination',
  'report.cat.incitement_violence': 'Incitement to violence',
  'report.cat.child_abuse': 'Child abuse',
  'report.cat.child_exploitation': 'Child exploitation',
  'report.cat.child_grooming': 'Grooming',
  'report.cat.human_trafficking': 'Human trafficking',
  'report.cat.sexual_exploitation': 'Sexual exploitation',
  'report.cat.terrorism': 'Terrorism',
  'report.cat.extremism': 'Extremism',
  'report.cat.self_harm': 'Self-harm',
  'report.cat.suicide': 'Suicide',
  'report.cat.fraud': 'Fraud',
  'report.cat.scam': 'Scam',
  'report.cat.doxxing': 'Doxxing',
  'report.cat.privacy_violation': 'Privacy violation',
  'report.cat.misinformation': 'Misinformation',
  'report.cat.other': 'Other',
  'report.group.general': 'General',
  'report.group.cybercrime': 'Cybercrime',
  'report.group.discrimination': 'Discrimination and hate',
  'report.group.child_safety': 'Child protection',
  'report.group.trafficking': 'Human trafficking',
  'report.group.terrorism': 'Terrorism',
  'report.group.safety': 'Personal safety',
  'report.group.fraud': 'Fraud',
  'search.popularTags': 'Popular hashtags',
  'search.noResults': 'No results for',
  'search.publishHashtags': 'Post with #hashtags so they appear here',
  'search.people': 'People',
  'search.membersCount': 'members',
  'tip.title': 'Send tip',
  'tip.desc': 'Support {name} with a crypto tip',
  'tip.chain': 'Chain',
  'tip.amount': 'Amount',
  'tip.message': 'Message (optional)',
  'tip.messagePlaceholder': 'Great content!',
  'tip.sent': 'Tip sent',
  'tip.note': 'Tips are symbolic and recorded on the platform.',
  'donation.body': 'To improve and keep our community safe, we need financial support to protect ourselves legally and cover infrastructure costs.',
  'donation.addressCopied': 'Address copied!',
  'donation.close': 'Understood, thank you!',
  'donation.footer': 'Every contribution helps keep PAPO as a safe, free digital space committed to the future of Africa.',
  'common.error': 'Error',
  'reaction.empower': 'Empower',
  'reaction.support': 'Support',
  'reaction.inspire': 'Inspire',
  'reaction.peace': 'Peace',
  'profile.loadError': 'Error loading profile',
  'profile.unfollowed': 'You unfollowed this user',
  'profile.followed': 'You are now following this user',
  'profile.listError': 'Error loading list',
  'profile.reactionError': 'Error reacting',
  'profile.updated': 'Profile updated',
  'profile.updateError': 'Error updating profile',
  'profile.photoUpdated': 'Photo updated',
  'profile.photoError': 'Error uploading image',
  'profile.memberSince': 'PAPO member',
  'profile.mutualFriends': 'mutual friends',
  'profile.noPosts': 'You haven\'t posted anything yet. Share something with the community!',
  'profile.noPostsOther': 'This user hasn\'t posted anything yet.',
  'groups.catAll': 'All',
  'groups.catGeneral': 'General',
  'groups.catWellness': 'Wellness',
  'groups.catMindfulness': 'Mindfulness',
  'groups.catCreativity': 'Creativity',
  'groups.catSupport': 'Support',
  'groups.catLearning': 'Learning',
  'groupDetail.loadError': 'Error loading group',
  'groupDetail.left': 'You left the group',
  'groupDetail.joined': 'You joined the group',
  'groupDetail.actionError': 'Error processing request',
  'groupDetail.reactionError': 'Error reacting',
  'settings.tabProfile': 'Profile',
  'settings.tabWellness': 'Wellness',
  'settings.tabNotifications': 'Notifications',
  'settings.tabPrivacy': 'Privacy',
  'settings.tabLegal': 'Legal / GDPR',
  'settings.tabAppearance': 'Appearance',
  'settings.saved': 'Profile updated',
  'settings.saveError': 'Error saving changes',
  'settings.imageTooBig': 'Image cannot exceed 5MB',
  'settings.photoUpdated': 'Photo updated',
  'settings.photoError': 'Error uploading image',
  'settings.deleteRequested': 'Deletion request registered',
  'settings.deleteError': 'Error requesting deletion',
  'settings.deleteCancelled': 'Deletion request cancelled',
  'msg.blockError': 'Error blocking user',
  'msg.caller': 'User',
  'msg.userNotFound': 'User not found',
  'msg.blockedFromMsg': 'Blocked from messages',
  'msg.userBlocked': 'User blocked',
  'msg.yourMessages': 'Your messages',
  'msg.selectOrSearch': 'Select a conversation or search someone to chat',
  'msg.noChatsYet': 'You have no conversations',
  'msg.searchToChat': 'Search people to start a chat',
  'msg.startConvo': 'Start the conversation',
  'bluetooth.papoUser': 'PAPO User',
  'settings.bioPlaceholder': 'Tell us about yourself...',
  'settings.save': 'Save changes',
  'settings.currentSession': 'Current session',
  'settings.maxDaily': 'Maximum daily time',
  'settings.privacyTitle': 'Privacy and security',
  'settings.deleteAccount': 'Delete my account',
  'settings.cancelDelete': 'Cancel deletion',
  'settings.requestDelete': 'Request account deletion',
  'settings.deleteConfirmTitle': 'Permanently delete account',
  'settings.cancel': 'Cancel',
  'settings.exportError': 'Error exporting data',
  'settings.title': 'Settings',
  'settings.logout': 'Log out',
  'settings.profileInfo': 'Profile information',
  'settings.nameLabel': 'Name',
  'settings.wellnessConfig': 'Digital wellness settings',
  'settings.exportData': 'Export my data',
  'settings.legalInfo': 'Legal information',
  'settings.dpo': 'Data Protection Officer',
  'settings.themeLabel': 'Theme',
  'settings.themeApplied': 'Theme applied',
  'settings.exportSuccess': 'Data exported successfully',
  'account.title': 'Account management',
  'account.subtitle': 'Data protection & privacy (GDPR)',
  'account.exportTitle': 'Download my data',
  'account.exportDesc': 'Download all your posts, messages, contacts and data in a compressed ZIP file. Right to data portability (GDPR Art. 20).',
  'account.downloadZip': 'Download ZIP',
  'account.deactivateTitle': 'Deactivate account',
  'account.deactivateDesc': 'Your profile will be hidden and you won\'t be able to log in. Your data is preserved. You can reactivate by contacting support.',
  'account.deactivateBtn': 'Deactivate my account',
  'account.deleteTitle': 'Delete account permanently',
  'account.deleteDesc': 'Permanently deletes all your data after a 30-day grace period. Right to erasure (GDPR Art. 17). You can cancel during the grace period.',
  'account.deleteBtn': 'Delete my account',
  'account.deleteConfirm': 'Delete in 30 days',
  'account.legalNotice': 'Your data protection rights are guaranteed under the General Data Protection Regulation (GDPR). For inquiries: dpo@papo.social',
  'account.exportSuccess': 'Data downloaded',
  'account.exportError': 'Error exporting data',
  'account.exporting': 'Generating...',
  'account.deactivateConfirmTitle': 'Deactivate your account?',
  'account.deactivateConfirmDesc': 'Your profile will be hidden from other users. You won\'t be able to log in until the account is reactivated. Your data will be preserved.',
  'account.deactivateConfirm': 'Yes, deactivate',
  'account.deactivated': 'Account deactivated',
  'account.deleteConfirmTitle': 'Delete your account permanently?',
  'account.deleteConfirmDesc1': 'This action is irreversible. After 30 days the following will be deleted:',
  'account.deleteItem1': 'Your profile and personal information',
  'account.deleteItem2': 'All your posts and comments',
  'account.deleteItem3': 'Your messages and conversations',
  'account.deleteItem4': 'Group memberships and contacts',
  'account.deleteConfirmDesc2': 'We recommend downloading your data before deleting your account.',
  'account.deleteScheduled': 'Deletion scheduled for 30 days',
  'account.deletionPending': 'Deletion scheduled',
  'account.deletionDate': 'Date:',
  'account.cancelDeletion': 'Cancel deletion',
  'account.deletionCancelled': 'Deletion cancelled',
  'account.error': 'Error processing request',
  'privacy.visibility': 'Visibility',
  'privacy.public': 'Public',
  'privacy.private': 'Private (contacts only)',
  'privacy.hidden': 'Hidden',
  'privacy.inviteContacts': 'Invite contacts',
  'privacy.searchContact': 'Search contact...',
  'privacy.noContacts': 'No contacts',
  'settings.username': 'Username',
  'settings.usernameDesc': 'A public alias others can see instead of your real name.',
  'settings.showEmail': 'Show email on profile',
  'settings.showEmailDesc': 'Let other users see your email on your profile.',
  'settings.profileVisible': 'Profile visible',
  'settings.profileVisibleDesc': 'Hide your profile from searches and visits. Others won\'t be able to find you.',
  'settings.saved': 'Saved',
  'settings.save': 'Save',
  'profile.followersTooltip': 'People who follow this profile',
  'profile.followingTooltip': 'People this profile follows',
  'profile.friendsTooltip': 'Mutual friendships',
  'profile.mutualTooltip': 'Friends in common',
  'friends.removeFriendTooltip': 'Remove friendship',
  'friends.pendingTooltip': 'Request sent, waiting for response',
  'friends.acceptTooltip': 'Accept friend request',
  'friends.addFriendTooltip': 'Send friend request',
  'suggestions.friendOfFriend': 'Friend of your friends',
  'settings.downloadBtn': 'Download my data',
  'settings.wellnessIntro': 'PAPO helps you maintain healthy social media usage.',
  'settings.breakReminders': 'Break reminders',
  'settings.breakInterval': 'Break interval',
  'settings.dailyLimit': 'Daily usage limit',
  'settings.breakSound': 'Soft sound when suggesting breaks',
  'settings.breakModeInfo': 'About break mode: When activated, you\'ll see a guided breathing exercise with relaxing animations. You can end the break at any time.',
  'settings.notifReactions': 'Reactions',
  'settings.notifComments': 'Comments',
  'settings.notifFollowers': 'New followers',
  'settings.notifMessages': 'Messages',
  'settings.notifMentions': 'Mentions',
  'settings.notifGroups': 'Group activity',
  'settings.pushNotif': 'Push notifications',
  'settings.pushNotifDesc': 'Receive notifications in your browser',
  'settings.enablePush': 'Enable push notifications',
  'settings.disablePush': 'Disable push notifications',
  'settings.publicProfile': 'Public profile',
  'settings.publicProfileDesc': 'Anyone can see your profile',
  'settings.showOnline': 'Show online status',
  'settings.showLastSeen': 'Show last seen',
  'settings.blockedUsers': 'Blocked users',
  'settings.blockedNone': 'You have no blocked users',
  'settings.unblock': 'Unblock',
  'settings.legalCommitment': 'We comply with GDPR, the Digital Services Act (DSA), the Convention on the Rights of the Child, the Palermo Protocol, the Budapest Convention and UN Security Council resolutions.',
  'settings.legalCommitmentTitle': 'PAPO\'s legal commitment:',
  'settings.notifReactionsDesc': 'When someone reacts to your posts',
  'settings.notifCommentsDesc': 'When someone comments on your posts',
  'settings.notifMessagesDesc': 'When you receive a new message',
  'settings.notifEvents': 'Events',
  'settings.notifEventsDesc': 'Upcoming event reminders',
  'settings.notifGroupsDesc': 'New posts in your groups',
  'settings.wellnessTip': 'Wellness tip:',
  'settings.wellnessTipText': 'Limiting notifications can help you reduce digital anxiety and improve your focus.',
  'settings.privacyIntro': 'Your privacy is our priority. PAPO will never sell your data.',
  'settings.publicProfileDesc2': 'Other users can see your profile',
  'settings.showOnlineDesc': 'Others see when you are online',
  'settings.allowDM': 'Allow direct messages',
  'settings.allowDMDesc': 'Anyone can send you messages',
  'settings.privacyCommitTitle': 'PAPO commitment:',
  'settings.privacyCommitText': 'Your personal data will never be sold or used for advertising. We only use it to improve your experience.',
  'settings.legalTitle': 'Legal rights and data protection',
  'settings.legalIntro': 'PAPO complies with GDPR, the EU Digital Services Act and International Public Law.',
  'settings.legalExportDesc': 'Download a complete copy of all your personal data: profile, posts, comments, messages, groups and reactions.',
  'settings.exporting': 'Exporting...',
  'settings.legalDeleteDesc': 'Your account will be permanently deleted after 30 days. All your data will be removed.',
  'settings.deleteWarning': 'Are you sure? This action is irreversible. Your account and all data will be permanently deleted.',
  'settings.deleteConfirm': 'Delete permanently',
  'settings.euRep': 'EU Representative',
  'settings.disputes': 'Dispute resolution',
  'settings.odrEU': 'EU ODR',
  'settings.transparencyReport': 'Transparency report',
  'settings.viewReport': 'View report',
  'settings.aiModeration': 'AI Moderation',
  'settings.aiModDesc': 'Content is automatically analyzed by AI',
  'settings.analyzed': 'Analyzed',
  'settings.approved': 'Approved',
  'settings.warned': 'Warned',
  'settings.hidden': 'Hidden/Escalated',
  'settings.loadingStats': 'Loading statistics...',
  'settings.dailyUsage': 'Daily usage',
  'settings.breakDesc': 'Suggest breaks after a period of usage',
  'settings.breakEvery': 'Suggest break every {min} minutes',
  'settings.dailyLimitDesc': 'Receive alert when approaching the limit',
  'settings.alertAt': 'Alert when you reach {min} minutes',
  'settings.wellnessSounds': 'Wellness sounds',
  'settings.notifTitle': 'Notification preferences',
  'settings.notifDesc': 'Configure which notifications you want to receive for a healthy platform usage.',
  'settings.appearanceTitle': 'Appearance',
  'settings.appearanceDesc': 'Customize how PAPO looks for you.',
  'settings.appearanceTip': 'Tip: All themes are optimized for extended reading and Dark mode reduces blue light emission.',
  'settings.saving': 'Saving...',
  'settings.hours': 'hours',
  'theme.light': 'Light',
  'theme.dark': 'Dark',
  'theme.midnight': 'Midnight',
  'theme.resistance': 'Resistance',
  'settings.cancelError': 'Error cancelling request',
  'settings.userUnblocked': 'User unblocked',
  'settings.unblockError': 'Error unblocking user',
  'settings.accountWillDelete': 'Your account will be deleted on {date}.',
  'settings.blockedOn': 'Blocked on {date}',
  'settings.bioLabel': 'Bio',
  'wallet.loadError': 'Error loading wallet',
  'wallet.demoFunded': 'Demo wallet funded',
  'wallet.fundError': 'Error funding wallet',
  'wallet.sendError': 'Transfer error',
  'wallet.swapError': 'Swap error',
  'wallet.stakeError': 'Staking error',
  'wallet.unstakeError': 'Error',
  'wallet.metamaskNotFound': 'MetaMask not detected. Install the extension.',
  'wallet.metamaskConnected': 'MetaMask connected',
  'wallet.metamaskError': 'Error connecting MetaMask',
  'wallet.tabPortfolio': 'Portfolio',
  'wallet.tabMarket': 'Market',
  'wallet.tabHistory': 'History',
  'wallet.tabStaking': 'Staking',
  'wallet.emptyWallet': 'Your wallet is empty',
  'wallet.fundDemo': 'Fund demo wallet',
  'wallet.activeStaking': 'Active staking',
  'wallet.withdraw': 'Withdraw',
  'wallet.availableStaking': 'Available for staking',
  'wallet.upToAPY': 'Up to {apy}% APY',
  'wallet.bricsBanner': 'BRICS+ multi-country QR payments — 600+ cryptocurrencies',
  'wallet.sendCrypto': 'Send crypto',
  'wallet.sendDesc': 'P2P transfer between PAPO users',
  'wallet.cryptocurrency': 'Cryptocurrency',
  'wallet.selectPlaceholder': 'Select...',
  'wallet.available': 'available',
  'wallet.recipientId': 'Recipient ID',
  'wallet.amount': 'Amount',
  'wallet.noteOptional': 'Note (optional)',
  'wallet.sending': 'Sending...',
  'wallet.sendBtn': 'Send',
  'wallet.sentTo': 'Sent to {name}',
  'wallet.receivedFrom': 'Received from {name}',
  'wallet.swapDesc': 'Exchange cryptocurrencies — 0.3% fee',
  'wallet.from': 'From',
  'wallet.to': 'To',
  'wallet.youWillReceive': 'You will receive',
  'wallet.rate': 'Rate',
  'wallet.swapping': 'Swapping...',
  'wallet.confirmSwap': 'Confirm swap',
  'wallet.stakeDesc': 'Earn yield on your cryptocurrencies',
  'wallet.annualYield': 'Estimated annual yield',
  'wallet.stakingProgress': 'Staking...',
  'wallet.confirmStaking': 'Confirm staking',
  'wallet.noTransactionsYet': 'No transactions yet',
  'wallet.inspired': 'Inspired by',
  'profile.noPhotos': 'You don\'t have photos yet. Share images with the community!',
  'profile.noPhotosOther': 'This user hasn\'t shared images yet.',
  'profile.editTitle': 'Edit profile',
  'profile.nameLabel': 'Name',
  'profile.bioLabel': 'Bio',
  'profile.bioPlaceholder': 'Tell us about yourself...',
  'profile.saveChanges': 'Save changes',
  'profile.searchByName': 'Search by name',
  'profile.noMutual': 'No mutual friends',
  'profile.mutualTitle': 'Mutual friends',
  'profile.followBack': "Follow back",
  'profile.followsYou': "Follows you",
  'profile.peopleYouMayKnow': "People you may know",
  'profile.mutualFriend': "mutual friend",
  'search.recent': "Recent searches",
  'search.clearAll': "Clear all",
  'notif.view': "View",
  'search.discover': "Search",
  'onboarding.skip': 'Skip',
  'onboarding.prev': 'Back',
  'onboarding.next': 'Next',
  'onboarding.finish': "Let's go!",
  'onboarding.home.title': 'Home',
  'onboarding.home.desc': 'Your feed: posts from friends and people you follow, ranked by who you interact with most.',
  'onboarding.explore.title': 'Explore',
  'onboarding.explore.desc': 'Discover posts, reels and new topics beyond your circle.',
  'onboarding.messages.title': 'Messages',
  "onboarding.messages.desc": "Chat privately in real time, with voice and video calls. Long-press a message to react or tap ↩ to reply.",
  'onboarding.lives.title': 'Lives',
  "onboarding.lives.desc": "Watch lives or start your own, get gifts and use Afro emojis and stickers in the chat.",
  'onboarding.wallet.title': 'Wallet',
  'onboarding.wallet.desc': 'Your multichain wallet: check balances, send and receive crypto and tips.',
  'onboarding.search.title': 'Search',
  'onboarding.search.desc': 'Find people, posts, groups and hashtags. Your recent searches are kept here.',
  'onboarding.notifications.title': 'Notifications',
  'onboarding.notifications.desc': 'See reactions, comments and friend requests instantly.',
  'onboarding.wellness.title': 'Wellness',
  'onboarding.wellness.desc': 'Track your daily screen time and take a break whenever you need it.',
  'onboarding.profile.title': 'Profile',
  "onboarding.profile.desc": "Edit your profile and see your friends. This menu has the PAPO Guide and what's new.",
  'landing.slides.kicker': 'Everything you can do',
  'landing.slides.heading': 'Discover PAPO, one feature at a time',
  'landing.slides.feed.title': 'Smart feed',
  'landing.slides.feed.desc': 'Your home learns who you interact with most and shows what truly matters from friends and people you follow first.',
  'landing.slides.wellness.title': 'Digital wellness',
  'landing.slides.wellness.desc': 'Usage timer, daily limit and guided breaks so social media gives you time back instead of taking it.',
  'landing.slides.lives.title': 'Lives with guests',
  'landing.slides.lives.desc': 'Go live, invite someone to split-screen with you and get reactions and tips in real time.',
  'landing.slides.offline.title': 'Messages without internet',
  'landing.slides.offline.desc': 'Chat over Bluetooth phone to phone when there is no signal — perfect for rural areas and emergencies.',
  'landing.slides.stickers.title': 'Afrocentric stickers',
  'landing.slides.stickers.desc': 'Express your identity with animated stickers inspired by African cultures, from the Sahel to the Atlas and the Cape.',
  'landing.slides.wallet.title': 'Multichain wallet',
  'landing.slides.wallet.desc': 'Store, send and receive crypto across several networks and support creators with direct tips.',
  'landing.slides.privacy.title': 'Privacy first',
  'landing.slides.privacy.desc': 'Your data is yours: private profiles, blocking, reporting and strict data-protection compliance.',
  'landing.slides.groups.title': 'Groups & events',
  'landing.slides.groups.desc': 'Build communities, organise meetups and celebrate with your people, online and in person.',
  'landing.slides.explore.title': 'Search & Explore',
  'landing.slides.explore.desc': 'Find people, posts, groups and trending hashtags, with filters and recent searches.',
  'landing.slides.languages.title': '4 languages & dual theme',
  'landing.slides.languages.desc': 'PAPO speaks Portuguese, English, Spanish and French, with light and dark mode as you like.',
  'landing.slides.try': 'Try it',
  'landing.demo.feed': 'Your feed',
  'landing.demo.react': 'Reactions',
  'landing.demo.live': 'Live',
  'landing.demo.chat': 'Messages',
  'landing.demo.guest': 'Guest',
  'landing.demo.msg1': 'Did you get to Tamanrasset ok?',
  'landing.demo.msg2': 'Yes! No signal, but PAPO works over Bluetooth 🙌🏽',
  'landing.demo.offline': 'Sent without internet',
  'testimonials.kicker': 'Community voices',
  'testimonials.heading': 'From Dakar to the Atlas, here is what our people say',
  'testimonials.formTitle': 'Share your experience',
  'testimonials.formDesc': 'Tell us what PAPO means to you. Once approved by the team, it will appear on the home page with your name and city.',
  'testimonials.quote': 'Your testimonial',
  'testimonials.quotePlaceholder': 'At least 20 characters...',
  'testimonials.city': 'City',
  'testimonials.country': 'Country',
  'testimonials.submit': 'Send testimonial',
  'testimonials.update': 'Update testimonial',
  'testimonials.delete': 'Delete',
  'testimonials.sent': 'Thank you! Your testimonial is under review',
  'testimonials.status.pending': 'Under review',
  'testimonials.status.approved': 'Approved',
  'testimonials.status.rejected': 'Rejected',
  'testimonials.status.all': 'All',
  'testimonials.adminTab': 'Testimonials',
  'testimonials.approve': 'Approve',
  'testimonials.reject': 'Reject',
  'testimonials.none': 'No testimonials here',
  'settings.tabCommunity': 'Community & help',
  'settings.replayGuide': 'Replay the guide',
  'settings.replayGuideDesc': 'Take the tour of PAPO’s main buttons again whenever you like.',
  'settings.replayGuideBtn': 'Show guide',
  'admin.signupSources': 'Sign-ups by feature (Try it)',
  'admin.noSignupSources': 'No sign-ups from the carousel yet',
  'auth.regNamePh': 'Your name',
  'auth.regEmailPh': 'you@email.com',
  'auth.regPassPh': 'At least 6 characters',
  'auth.regConfirmPh': 'Repeat your password',
  'auth.regOrWith': 'or sign up with',
  'upload.optimized': 'Photo optimized',
  'stream.share': 'Share',
  'stream.shareTitle': 'Share live',
  'stream.shareText': 'Join my live on PAPO!',
  'stream.searchPeople': 'Search friends and people you follow',
  'stream.noPeople': 'No people to show',
  'stream.sendTo': 'Send',
  'stream.sharedWith': 'Live sent to',
  'stream.copyLink': 'Copy link',
  'stream.linkCopied': 'Link copied!',
  'stream.more': 'More',
  'stream.tapForSound': 'Tap to turn on sound',
  'stream.ended': 'This live has ended',
  'stream.removeGuest': 'Remove guest',
  'stream.youWereRemoved': 'The host removed you from the live',
  'stream.guestsFull': 'This live already has 4 guests',
  'stream.weakConnection': 'Your connection is weak: video may freeze',
  'stream.quality.good': 'Good connection',
  'stream.quality.fair': 'Fair connection',
  'stream.quality.poor': 'Poor connection',
  'stream.latency': 'Latency',
  'stream.packetLoss': 'Packet loss',
  'stream.cover': 'Cover (optional)',
  'stream.coverHint': 'Shown when the link is shared on WhatsApp or Facebook',
  'stream.notifyFollowers': 'Notify my friends',
  'stream.followersNotified': 'Friends notified',
  'stream.followersAlreadyNotified': 'You already notified your friends for this live',
  'stream.askToJoin': 'Ask to join',
  'stream.cancelRequest': 'Cancel',
  'stream.joinRequests': 'Requests',
  'stream.wantsToJoin': 'wants to join the live',
  'stream.requestRejected': 'The host declined your request. You can ask again in 30 s',
  'stream.accept': 'Accept',
  'stream.reject': 'Decline',
  'stream.liveNow': 'Live',
  'profile.noFollowers': 'No followers yet',
  'profile.notFollowing': 'Not following anyone yet',
  'profile.reactions': 'reactions',
  'profile.gallery': 'Gallery',
  'profile.whatToShare': 'What do you want to share, {name}?',
  'post.video': 'Video',
  'post.photo': 'Photo',
  'post.link': 'Link',
  'videoCall.connecting': 'Connecting...',
  'videoCall.ringing': 'Calling...',
  'videoCall.media': 'Allow microphone access to make a call.',
  'videoCall.connection': 'Connection lost. Please try the call again.',
  'videoCall.timeout': 'No answer. Please try again later.',
  'videoCall.rejected': 'The call was declined or the person is busy.',
  'videoCall.ended': 'Call ended',
  'bluetooth.enable': 'Enable',
  'bluetooth.disable': 'Disable',
  'bluetooth.searchPeers': 'Search nearby peers to connect',
  'bluetooth.noMessages': 'No messages yet. Send the first one!',
  'bluetooth.panicTitle': 'Panic mode - Delete all data',
  'bluetooth.tagline': 'No internet - No censorship - End-to-end encrypted',
  'bluetooth.nearbyPeers': 'Nearby peers',
  'groups.joinToPost': 'Join the group to see and create posts.',
  'auth.authError': 'Authentication error',
  'stream.title': 'Live Streaming',
  'stream.subtitle': 'Live broadcasts from the PAPO community',
  'stream.category': 'Category',
  'stream.allLives': 'All',
  'stream.cat.general': 'General',
  'stream.cat.music': 'Music',
  'stream.cat.talk': 'Talk',
  'stream.cat.gaming': 'Gaming',
  'stream.cat.cooking': 'Cooking',
  'stream.cat.education': 'Education',
  'stream.cat.fitness': 'Fitness',
  'stream.cat.culture': 'Culture',
  'stream.goLive': 'Go Live',
  'stream.goLiveDesc': 'Start a live broadcast for the community',
  'stream.titleLabel': 'Title',
  'stream.titlePlaceholder': 'Give your stream a title...',
  'stream.descLabel': 'Description',
  'stream.descPlaceholder': 'What will you talk about?',
  'stream.privacy': 'Privacy',
  'stream.public': 'Public',
  'stream.private': 'Private',
  'stream.startStreaming': 'Start streaming',
  'stream.createError': 'Error creating stream',
  'stream.end': 'End',
  'stream.guestJoined': 'joined the live!',
  'stream.guestDeclined': 'declined the invite',
  'stream.guestInviteTitle': 'Join the Live',
  'stream.guestInviteDesc': 'The host invites you to join with your camera and microphone. All viewers will see and hear you.',
  'stream.guestAccepted': 'You joined the live! Your camera is active.',
  'stream.joinLive': 'Join Live',
  'stream.decline': 'Decline',
  'stream.leaveGuest': 'Leave Live',
  'stream.guests': 'guests',
  'stream.you': 'You',
  'stream.liveChat': 'Live chat',
  'stream.chatPlaceholder': 'Write a message...',
  'stream.sendTip': 'Send tip',
  'stream.tipSent': 'Tip sent!',
  'stream.tipped': 'tipped',
  'stream.inviteCohost': 'Invite co-host',
  'stream.cohostInvited': 'Co-host invited!',
  'stream.searchUser': 'Search user...',
  'stream.noStreams': 'No live streams',
  'stream.beFirst': 'Be the first to go live!',
  'stream.notFound': 'Stream not found',
  'stream.hasEnded': 'The stream has ended',
  'stream.cameraError': 'Error accessing camera',
  // Screen Share
  'stream.screenShare': 'Screen Share',
  'stream.screenShareStarted': 'Screen sharing started',
  'stream.screenShareError': 'Error sharing screen',
  // Story Highlights
  'highlights.title': 'Highlights',
  'highlights.added': 'Added to highlights!',
  'highlights.removed': 'Removed from highlights',
  'highlights.story': 'Highlight',
  'highlights.remove': 'Remove',
  // Post Scheduling
  'post.schedule': 'Schedule',
  'post.scheduleFor': 'Schedule for',
  'post.willPublishAt': 'Will be published at',
  'post.scheduled': 'Post scheduled!',
  'post.scheduleBtn': 'Schedule',
  'post.scheduledLabel': 'Scheduled',
  // Post Preview
  'post.previewTitle': 'Post preview',
  // Highlight Albums
  'albums.new': 'New',
  'albums.create': 'Create album',
  'albums.edit': 'Edit album',
  'albums.save': 'Save',
  'albums.delete': 'Delete',
  'albums.created': 'Album created!',
  'albums.updated': 'Album updated!',
  'albums.deleted': 'Album deleted!',
  'albums.empty': 'No stories in this album',
  'albums.nameLabel': 'Album name',
  'albums.namePlaceholder': 'e.g. Travels, Moments...',
  'albums.selectStories': 'Select stories',
  'albums.noHighlights': 'Mark stories as highlights first',
  // Annotations
  'annotations.pen': 'Pen',
  'annotations.text': 'Text',
  'annotations.rect': 'Rectangle',
  'annotations.arrow': 'Arrow',
  'annotations.eraser': 'Eraser',
  'annotations.clear': 'Clear all',
  'annotations.enterText': 'Enter text:',
  // Explore
  'explore.title': 'Explore',
  'explore.subtitle': 'Posts from friends of friends',
  'explore.all': 'All',
  'explore.photos': 'Photos',
  'explore.videos': 'Videos',
  'explore.empty': 'No media content yet',
  'explore.emptyFeed': 'Nothing to explore yet',
  'explore.emptyFeedDesc': 'Add more friends to discover posts from friends of friends',
  'explore.loadMore': 'Load more',
  'explore.loading': 'Loading...',
  // Theme toggle
  'nav.explore': 'Explore',
  'nav.darkMode': 'Dark mode',
  'nav.lightMode': 'Light mode',
  // Music
  'music.selectTrack': 'Select music',
  'music.search': 'Search music...',
  'music.addMusic': 'Add music',
  'stickers.title': 'Stickers',
  'stickers.placed': 'stickers',
  'stickers.power': 'Power',
  'stickers.culture': 'Culture',
  'stickers.nature': 'Nature',
  'stickers.food': 'Food',
  'stickers.unity': 'Unity',
  // Post Analytics
  'post.analytics': 'Analytics',
  'post.analyticsTitle': 'Post analytics',
  'post.views': 'Views',
  'post.shares': 'Shares',
  'post.linkCopied': 'Link copied!',
  'post.reactions': 'Reactions',
  // Explore Reels
  'explore.reels': 'Reels',
  'explore.viewAll': 'View all',
  // Voice Messages
  'voice.voiceMessage': 'Voice message',
  'voice.sendError': 'Error sending voice message',
  'voice.micError': 'Error accessing microphone',
  "gifts.title": "Send a gift",
  "gifts.send": "Send",
  "gifts.balance": "Balance",
  "gifts.coins": "PAPO coins",
  "gifts.payWithCoins": "Coins",
  "gifts.payWithCrypto": "Crypto wallet",
  "gifts.commissionNote": "Each gift includes a 0.99% PAPO fee.",
  "gifts.cryptoNote": "1 coin = 0.01 USD, charged to your wallet.",
  "gifts.sent": "Gift sent!",
  "gifts.insufficient": "Insufficient balance",
  "gifts.sentBy": "{name} sent {gift}",
  "gifts.earnings": "Gifts received",
  "gifts.earningsDesc": "Turn your gift coins into a recorded tip in your balance.",
  "gifts.convert": "Convert to tip",
  "gifts.converted": "{n} coins converted to a tip",
  "gifts.noEarnings": "No gifts to convert yet",
  "gifts.djembe": "Djembe",
  "gifts.kente": "Kente",
  "gifts.sankofa": "Sankofa",
  "gifts.baobab": "Baobab",
  "gifts.mask": "Mask",
  "gifts.amazigh": "Amazigh Yaz",
  "gifts.lion": "Lion",
  "gifts.crown": "Crown",
  "mods.title": "Moderators",
  "mods.desc": "Pick up to 3 friends or people you follow to moderate the chat.",
  "mods.search": "Search friends",
  "mods.add": "Appoint",
  "mods.remove": "Remove",
  "mods.limit": "Maximum 3 moderators",
  "mods.none": "No friends or followed people to show",
  "mods.granted": "{name} made you a moderator of their live",
  "mods.deleteMsg": "Delete message",
  "mods.muteChat": "Mute in chat",
  "mods.unmuteChat": "Allow chat",
  "mods.kick": "Remove from live",
  "mods.kickConfirm": "Remove {name} from this live?",
  "mods.userKicked": "{name} was removed",
  "mods.kicked": "You were removed from this live",
  "mods.youAreMuted": "A moderator muted you in the chat",
  "mods.youAreUnmuted": "You can chat again",
  "sched.schedule": "Schedule for later",
  "sched.create": "Schedule live",
  "sched.created": "Live scheduled. Your friends can set a reminder.",
  "sched.invalidDate": "Pick a future date (max 30 days)",
  "sched.upcoming": "Coming up",
  "sched.remind": "Remind me",
  "sched.reminded": "We will remind you",
  "sched.remindOn": "We will remind you 10 min before and when it starts",
  "sched.startNow": "Start now",
  "sched.cancel": "Cancel",
  "sched.cancelConfirm": "Cancel this scheduled live?",
  "sched.cancelled": "Scheduled live cancelled",
  "admin.commissions": "Commissions",
  "admin.commissionsCoins": "Coins collected (PAPO account)",
  "admin.commissionsRate": "Fee rate",
  "stickers.amazigh_dancer": "Amazigh dancer",
  "stickers.mint_tea": "Mint tea",
  "stickers.gnawa": "Gnawa musician",
  "stickers.afro_pick": "Afro pick",
  "stickers.boombox": "Breakdance",
  "stickers.jazz": "Jazz",
  "stickers.steelpan": "Steelpan",
  "stickers.carnival": "Carnival",
  "stickers.reggae_lion": "Reggae lion",
  "stickers.capoeira": "Capoeira",
  "stickers.conga": "Conga",
  "stickers.palenquera": "Palenquera",
  "stickers.didgeridoo": "Didgeridoo",
  "stickers.kangaroo": "Dot-art kangaroo",
  "stickers.group.moor": "Moorish & Amazigh Africa",
  "stickers.group.afroamerican": "African-American",
  "stickers.group.afrocaribbean": "Afro-Caribbean",
  "stickers.group.afrolatin": "Afro-Latin",
  "stickers.group.aboriginal": "Aboriginal Australian",
  "coins.recharge": "Top up",
  "coins.shopTitle": "Top up PAPO coins",
  "coins.shopDesc": "Pay with your crypto wallet. 1 coin = 0.01 USD.",
  "coins.fee": "fee",
  "coins.commissionNote": "Each purchase includes a 0.99% PAPO fee.",
  "coins.bought": "+{n} coins added!",
  "coins.insufficientCrypto": "Not enough {sym} in your wallet",
  "gifts.topGifters": "Top gifters",
  "sched.addCalendar": "Add to calendar",
  "admin.commissionsDaily": "Commissions per day",
  "admin.source.live_gift": "Live gift",
  "admin.source.coin_purchase": "Coin purchase",
  "stickers.tabEmojis": "Emojis",
  "stickers.tabAfro": "Afro Emojis",
  "stickers.tabDiaspora": "Diaspora",
  "stickers.recent": "Recent",
  "stickers.popular": "Popular animated",
  "admin.commissionsCrypto": "Crypto commissions",
  "admin.coinReserve": "Coin sales reserve",
  "coins.walletBalance": "Wallet balance",
  "admin.commissionsCount": "Commissions recorded",
  "stickers.kwanzaa": "Kwanzaa",
  "stickers.samba": "Carnival samba",
  "stickers.yennayer": "Yennayer",
  "stickers.juneteenth": "Juneteenth",
  "stickers.elephant": "Elephant",
  "stickers.giraffe": "Giraffe",
  "stickers.zebra": "Zebra",
  "stickers.hippo": "Hippo",
  "stickers.jollof": "Jollof rice",
  "stickers.feijoada": "Feijoada",
  "stickers.ackee": "Ackee & saltfish",
  "stickers.tagine": "Tagine",
  "stickers.premium": "Premium packs",
  "stickers.unlock": "Unlock",
  "stickers.unlocked": "Pack unlocked! Balance: {balance} coins",
  "stickers.pack.fiestas": "Diaspora celebrations",
  "stickers.pack.fauna": "African animals",
  "stickers.pack.sabores": "Traditional food",
  "badges.rank1": "Top 1 gifter",
  "badges.rank2": "Top 2 gifter",
  "badges.rank3": "Top 3 gifter",
  "badges.inProgress": "in progress",
  "badges.tooltip": "Rank {rank} of the month · {coins} coins gifted",
  "badges.leaderboard": "Top gifters this month",
  "payment.checking": "Confirming your payment…",
  "payment.success": "Payment complete!",
  "payment.cancelled": "Payment cancelled",
  "payment.error": "We could not confirm the payment",
  "payment.coinsAdded": "Your PAPO coins are in your balance",
  "payment.back": "Back to Lives",
  "coins.payCard": "Card",
  "coins.total": "Total",
  "admin.source.sticker_pack": "Sticker pack",
  "admin.source.coin_purchase_card": "Coin purchase (card)",
  "admin.usdCard": "USD (card)",
  "admin.commissionsByCurrency": "Commissions by currency",
  "coins.shopDescCard": "Pay securely by card with Stripe. 1 coin = 0.01 USD.",
  "reset.forgotLink": "Forgot your password?",
  "reset.forgotTitle": "Recover your account",
  "reset.forgotSubtitle": "Enter your email and we'll send you a link to choose a new password.",
  "reset.sendLink": "Send link",
  "reset.sent": "If the email is registered, you'll get a link in a few minutes. Check spam too. The link expires in 1 hour.",
  "reset.resetTitle": "New password",
  "reset.resetSubtitle": "Choose a password with at least 8 characters.",
  "reset.newPassword": "New password",
  "reset.confirmPassword": "Repeat password",
  "reset.save": "Save password",
  "reset.done": "Password updated. You can sign in now.",
  "reset.invalid": "This link is invalid or has expired.",
  "reset.requestNew": "Request a new link",
  "reset.tooShort": "At least 8 characters",
  "reset.mismatch": "Passwords don't match",
  "reset.adminLink": "Reset link",
  "reset.linkCopied": "Link copied (valid 1 hour). Send it to the user.",
  "auth.tooManyAttempts": "Too many attempts. Wait 15 minutes.",
  "authToggle.login": "Log in",
  "authToggle.register": "Sign up",
  "authToggle.label": "PAPO access",
  "download.title": "Get PAPO",
  "download.desc": "Install the app on your phone: free, lightweight, no app store needed.",
  "download.android": "Download for Android",
  "download.ios": "Download for iPhone",
  "download.installed": "PAPO is already installed on this device.",
  "download.androidTitle": "Install on Android",
  "download.iosTitle": "Install on iPhone / iPad",
  "download.android1": "Open this page in Chrome.",
  "download.android2": "Tap the ⋮ menu (top right).",
  "download.android3": "Choose “Install app” or “Add to Home screen”.",
  "download.ios1": "Open this page in Safari.",
  "download.ios2": "Tap the Share button (square with an up arrow).",
  "download.ios3": "Choose “Add to Home Screen” and tap “Add”.",
  "download.done": "Got it",
  "videoCall.speaker": "Speaker",
  "videoCall.mic": "Mic",
  "videoCall.camera": "Camera",
  "videoCall.hangup": "Hang up",
  "emojiCat.afro": "Africa & Angola",
  "emojiCat.afro-unity": "Unity & Resistance",
  "emojiCat.afro-nature": "African Nature",
  "emojiCat.afro-food": "Flavors of Angola",
  "emojiCat.happy": "Happy",
  "emojiCat.love": "Love",
  "emojiCat.gesture": "Gestures",
  "emojiCat.hearts": "Hearts",
  "emojiCat.celebration": "Celebration",
  "emojiCat.nature": "Nature",
  "videoCall.incoming": "Incoming video call...",
  "video.processing": "Optimizing video… (this may take a moment)",
  "video.processingShort": "Optimizing…",
  "video.trimmedStory": "Your video was trimmed to 2 minutes for the story",
  "video.trimmedPost": "Your video was trimmed to 10 minutes",
  "video.failed": "The video could not be processed",
  "videoCall.switchCamera": "Flip",
  "stories.maxSize": "Max 500MB",
  "reactions.title": "Reactions",
  "reactions.all": "All",
  "reactions.remove": "Remove my reaction",
  "reactions.you": "You",
  "iosPush.installTitle": "Get notifications on your iPhone",
  "iosPush.step1": "Tap the Safari Share button",
  "iosPush.step2": "Choose “Add to Home Screen”",
  "iosPush.step3": "Open PAPO from the icon and turn on notifications",
  "iosPush.activateTitle": "Turn on notifications",
  "iosPush.activateDesc": "Hear about messages, friends and events instantly.",
  "iosPush.activate": "Enable notifications",
  "iosPush.later": "Later",
  "groups.backToGroups": "Back to groups",
  "groups.aboutGroup": "About this group",
  "download.safari1": "Tap the Share button (square with an ⬆ arrow) in the Safari bar at the bottom.",
  "download.safari2": "Scroll down and choose “Add to Home Screen”.",
  "download.safari3": "Tap “Add”: the PAPO icon will appear on your Home Screen.",
  "download.chrome1": "Tap the Share button (square with an ⬆ arrow) at the top right, next to the address.",
  "download.chrome2": "Choose “Add to Home Screen” (scroll the list if you don’t see it).",
  "download.chrome3": "Tap “Add”: the PAPO icon will appear on your Home Screen.",
  "download.firefox1": "Tap the ☰ menu at the bottom right.",
  "download.firefox2": "Choose “Share”, then “Add to Home Screen”.",
  "download.firefox3": "Tap “Add”: the PAPO icon will appear on your Home Screen.",
  "download.iosNote": "Apple doesn’t allow websites to install with one button: it’s done from the Share menu.",
  "download.copyLink": "Copy link",
  "download.linkCopied": "Link copied",
  "download.arrowHint": "Share is here",
  "download.animCopy": "Copy",
  "download.animAdd": "Add to Home Screen",
  "download.animStep1": "1 · Tap Share",
  "download.animStep2": "2 · “Add to Home Screen”",
  "download.animStep3": "3 · PAPO is on your iPhone!",
  "reply.reply": "Reply",
  "reply.replyingTo": "Replying to",
  "reply.cancel": "Cancel reply",
  "emailPrivacy.show": "Show my email to everyone",
  "emailPrivacy.hide": "Hide my email",
  "emailPrivacy.nowVisible": "Your email is now visible to everyone",
  "emailPrivacy.nowHidden": "Your email is hidden",
  "emailPrivacy.publicLabel": "Public",
  "emailPrivacy.hiddenLabel": "Hidden",
  "audience.public": "Public",
  "audience.friends": "Friends",
  "audience.private": "Only me",
  "audience.onlyMe": "Only you",
  "audience.who": "Who can see this?",
  "audience.saved": "Privacy updated",
  "privacyPanel.title": "Who sees your data",
  "privacyPanel.desc": "A summary of what each person sees: the public, your friends and only you.",
  "privacyPanel.data": "Data",
  "privacyPanel.nameBio": "Name, photo and bio",
  "privacyPanel.email": "Email",
  "privacyPanel.phone": "Phone",
  "privacyPanel.birthdate": "Date of birth",
  "privacyPanel.notSet": "Not added yet (Edit profile)",
  "privacyPanel.emailHint": "Show or hide your email with the eye icon on your profile or the switch below.",
  "profile.phoneLabel": "Phone",
  "profile.birthdateLabel": "Date of birth",
  "profile.personalHint": "Optional. Only you see them by default; choose who can see them with the eye icon on your profile.",
  "embed.play": "Play video from",
  "embed.openIn": "Open in",
};
